var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69794 15.3961C8.17503 15.3961 6.68637 14.9445 5.42011 14.0984C4.15385 13.2523 3.16697 12.0498 2.58418 10.6428C2.00138 9.23578 1.84884 7.68757 2.14594 6.19392C2.44305 4.70026 3.1765 3.32828 4.25336 2.25141C5.33023 1.17455 6.70209 0.441158 8.19575 0.144051C9.6894 -0.153055 11.2377 -0.000572085 12.6447 0.582223C14.0517 1.16502 15.2542 2.15196 16.1003 3.41822C16.9464 4.68448 17.3979 6.1732 17.3979 7.69611C17.396 9.73771 16.5842 11.6952 15.1406 13.1388C13.6969 14.5824 11.7395 15.3943 9.69794 15.3961ZM9.69794 3.84913C8.93668 3.84913 8.19248 4.07488 7.55952 4.49781C6.92655 4.92074 6.43336 5.52185 6.14204 6.22517C5.85071 6.92848 5.77453 7.70241 5.92304 8.44904C6.07156 9.19568 6.43797 9.88146 6.97626 10.4197C7.51456 10.958 8.20034 11.3246 8.94697 11.4732C9.6936 11.6217 10.4675 11.5454 11.1708 11.2541C11.8742 10.9628 12.4755 10.4695 12.8984 9.8365C13.3213 9.20353 13.5471 8.45939 13.5471 7.69813C13.5457 6.67772 13.1397 5.69945 12.4182 4.97791C11.6966 4.25637 10.7184 3.85045 9.69794 3.84913Z",
    fill: "#00FFE6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.317 29.396C17.0643 29.3961 16.814 29.3464 16.5804 29.2498C16.3469 29.1532 16.1347 29.0115 15.9559 28.8328C15.7772 28.6542 15.6352 28.442 15.5384 28.2085C15.4417 27.975 15.392 27.7247 15.392 27.472V25.547C15.392 20.727 13.233 17.847 9.61803 17.847C6.00303 17.847 3.84508 20.725 3.84508 25.547V27.472C3.83362 27.9748 3.62564 28.4532 3.26598 28.8047C2.90631 29.1563 2.42346 29.3531 1.92052 29.3531C1.41757 29.3531 0.934479 29.1563 0.574814 28.8047C0.215149 28.4532 0.00741884 27.9748 -0.00404358 27.472V25.547C-0.00404358 17.57 4.829 14 9.619 14C14.409 14 19.2421 17.57 19.2421 25.547V27.472C19.2418 27.9824 19.0388 28.4717 18.6778 28.8325C18.3169 29.1933 17.8274 29.396 17.317 29.396Z",
    fill: "#00FFE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.396,
    height: 15.396,
    fill: "white",
    transform: "translate(2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.245,
    height: 15.396,
    fill: "white",
    transform: "translate(0 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser);
export default __webpack_public_path__ + "static/media/ico-user.0a1c19ec.svg";
export { ForwardRef as ReactComponent };